import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation UpdateRegistrationField(
    $column: Int!
    $enabled: Boolean
    $formId: Int!
    $group: String
    $id: Int!
    $label: String
    $multiselect: Boolean
    $options: [String]
    $required: Boolean!
    $row: Int!
    $helpText: String
  ) {
    updateRegistrationFormField(
      column: $column
      enabled: $enabled
      formId: $formId
      group: $group
      id: $id
      label: $label
      multiselect: $multiselect
      options: $options
      required: $required
      row: $row
      helpText: $helpText
    ) {
      column
      enabled
      formFieldDefinitionId
      formId
      group
      id
      label
      multiselect
      options
      required
      row
      target
      type
      helpText
    }
  }
`;
